// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"90e97bda","104":"71f75657","225":"3b4c4d91","382":"b645d1b0","429":"cb7cd85b","949":"33dcd01d"}[chunkId] + ".chunk.js";
};